const config = {
    apiUrl: 'https://treemap-test-backend.herokuapp.com/v1/',
    mapboxToken: 'pk.eyJ1IjoidmV5eWRhbnQiLCJhIjoiY2tnM253MGlwMGJwejJ3cGpnY2Z4MndoayJ9._yAhXrsBN98XzbyNFj_kHA',
    apiKey: 'wg3fdFzAeKZAa13NSSdAx2v0uCqmAtiLtLM7iiNJQuM',
};

export default config;
